module.exports = "/_next/static/images/512x512-970776eda9031804c18a6f8c0cb10028.png";